export enum EnrollmentApplicationStatus {
  Discrepancy = 1,
}
